import React from 'react';

const Tokenomics = () => {
  return (
    <section id="flokinomics" className="flokinomics-section">
      <div className="flokinomics-title">
        <div className="toco-title-hr-wrap">
          <hr className="toco-full-hr" style={{ marginBottom: '18px' }} />
          <span style={{ fontSize: '44px', color: 'var(--text-secondary)', letterSpacing: '2px' }}>Lindy Paper</span>
          <hr className="toco-full-hr" style={{ marginTop: '18px' }} />
        </div>
      </div>
      <div className="flokinomics-content">
        <div style={{ textAlign: 'center', padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
          <p style={{ fontSize: '24px', color: 'var(--text-primary)', lineHeight: '1.6', marginBottom: '30px' }}>
            The Lindy Effect is a theory about how long things last. It states that for certain, non-perishable ideas, technologies, or cultural phenomena: The longer they've already been around/ prevalent, the longer they're likely to continue doing so.
          </p>
          <img
            src="/lindyPaper.jpg"
            alt="Lindy Paper"
            style={{
              maxWidth: '500px',
              width: '100%',
              height: 'auto',
              borderRadius: '12px',
              border: '3px solid var(--accent-color)'
            }}
          />
        </div>
      </div>
            <div style={{ textAlign: 'center', marginTop: '18px' }}>
        <span style={{ fontSize: '30px', color: 'var(--text-secondary)', letterSpacing: '2px' }}>CONTRACT ADDRESS</span><br />
        <span style={{ fontSize: '28px', color: 'var(--text-primary)', wordBreak: 'break-all', padding: '0 10px' }}>
          5aW63GU53U9iQR5KgyFQq1bK2FymQhwB2qxWdWGepump
        </span>
      </div>
    </section>
  );
};

export default Tokenomics;
